import { JsonApiResource } from 'types/store/jsonApi';
import {
  RequestDrillDownApiResponse,
  ProjectDrillDownApiResponse,
  TaskDrillDownApiResponse,
  UserDrillDownApiResponse,
  CapacityManagementDrillDownApiResponse,
  EventDrillDownApiResponse,
} from './types';
import {
  CapacityManagementDrillDownItem,
  EventDrillDownItem,
  ProjectDrillDownItem,
  RequestsDrillDownItem,
  TaskDrillDownItem,
  UserDrillDownItem,
} from 'types/store/normalized/insightsDrillDown';
import { RequestStatus } from 'utils/types/request';
import { titleToSnakeCase } from 'utils/functions/dashboard';

const mapRequestDrilldownStatusToRequestStatus = (
  status: string
): RequestStatus => {
  const status_code = titleToSnakeCase(status || '');
  switch (status_code) {
    case 'in_review':
      return 'submitted';
    case 'declined':
      return 'rejected';
    // CGP-271: the API label "Pending Approval" diverges from the enum value
    case 'pending_approval':
      return 'pending_page_approval';
    default:
      return status_code as RequestStatus;
  }
};

export const transformRequestDrilldownData = (
  apiData: JsonApiResource<RequestDrillDownApiResponse>[]
): RequestsDrillDownItem[] =>
  apiData.map((apiItem) => {
    const { is_json_schema, ...rest } = apiItem.attributes;
    return {
      ...rest,
      id: apiItem.id,
      request_status: mapRequestDrilldownStatusToRequestStatus(
        apiItem.attributes.request_status
      ),
      isJsonSchema: is_json_schema,
    };
  });

export const transformProjectDrilldownData = (
  apiData: JsonApiResource<ProjectDrillDownApiResponse>[]
): ProjectDrillDownItem[] =>
  apiData.map((apiItem) => {
    return {
      ...apiItem.attributes,
      id: apiItem.id,
    };
  });

export const transformTaskDrilldownData = (
  apiData: JsonApiResource<TaskDrillDownApiResponse>[]
): TaskDrillDownItem[] =>
  apiData.map((apiItem) => {
    return {
      ...apiItem.attributes,
      id: apiItem.id,
    };
  });

export const transformUserDrilldownData = (
  apiData: JsonApiResource<UserDrillDownApiResponse>[]
): UserDrillDownItem[] =>
  apiData.map((apiItem) => {
    return {
      ...apiItem.attributes,
      id: apiItem.id,
    };
  });

export const transformCapacityManagementDrilldownData = (
  apiData: JsonApiResource<CapacityManagementDrillDownApiResponse>[]
): CapacityManagementDrillDownItem[] =>
  apiData.map((apiItem) => {
    return {
      ...apiItem.attributes,
      id: apiItem.id,
    };
  });

export const transformEventDrilldownData = (
  apiData: Array<JsonApiResource<EventDrillDownApiResponse>>
): Array<EventDrillDownItem> =>
  apiData.map((apiItem) => {
    return {
      ...apiItem.attributes,
      id: apiItem.id,
    };
  });
